import React, { useCallback } from 'react';
import styled from 'styled-components/macro';

import useFlavorStore from '../../../../common/store/useFlavorStore';
import { Flavor } from '../../../../common/types';
import data from '../../data';
import Logo, { Wrapper as _Logo } from '../../Logo';
import Link from './Link';
import useSection from './useSection';

const Wrapper = styled.div(({ $active }: { $active: boolean }) => `
  position: absolute;
  height: 100%;
  top: 0;
  left: 50%;

  clip-path: circle(${$active ? "90vh" : "0"});
  
  transition: 0.5s clip-path;
  animation-timing-function: ease-in-out;
`);

const Container = styled.div(({ $flavor }: { $flavor: Flavor }) => `
  position: fixed;
  z-index: 19;
  top: 0;
  left: 0;

  height: 100%;
  width: 100%;

  cursor: auto;
  background: #f9ecc2;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${_Logo} {
    position: absolute;
    top: 7%;
    left: 50%;
    transform: translateX(-50%);

    width: 90rem;
  }
`);

const Overlay = ({ active, setShow }: {
  active: boolean,
  setShow: (show: boolean) => void
}) => {

  const flavor = useFlavorStore(useCallback(state => state.flavor, []));
  const section = useSection();

  return (
    <Wrapper
      $active={active}
      onClick={e => e.stopPropagation()}
    >
      <Container $flavor={flavor}>
        <Logo />

        <div>
          {data.map((item, i) =>
            <Link
              key={i}
              number={`0${i + 1}`}
              label={item.label}
              to={item.to}
              active={section - 1 === i}
              setShow={setShow}
            />
          )}
        </div>
      </Container>
    </Wrapper>
  );
}

export default Overlay;